// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_NJA","cls2":"ExportFormatModal-cls2_eES ExportFormatModal-cls1_NJA"};